import defaultPortrait from "assets/images/default_portrait.png"

/**
 * 当前插件仅在布局组件中的按钮中使用
 * 点击按钮，导出当前用户的pdf，需要通过当前userinfo
 */
export default {
  computed:{
    ipPreContent(){
      let preContent=''
      if(!this.options.isShowPreContent){
        return preContent
      }
      if(this.options.preContentType === 1){
        preContent = this.options.outPreContent
      }else{
        preContent = this.options.inPreContent
      }
      return preContent
    },
    ipPreContentStyle(){
      let otherStyle={
        marginRight: this.options.preContentMargin+'px'
      }
      return {
        ...this.colorStyle,
        ...otherStyle
      }
    },
    isIp(){
      return this.options.pluginName?.includes("getIpPlugin") || false
    },
  },
  created(){
    if(this.isIp){
      this.getIpData()
    }
  },
  methods: {
    getIpData(){
      this.$API.getIP().then(res => {
        if(res.data.code === 1) {
          let preContentType
          if(res.data.data.inWhiteList ){
            // 校内ip
            preContentType = 0
          }else{
            // 校外ip
            preContentType = 1
          }
          this.$changeOptionsEV([preContentType,res.data.data.ip], ["preContentType","content"], false, false, false, true)
        }
      })
    }
  }
}
